import type { ReplayJson } from './types';

export function parseJoinReplayIdFromHash(hash: string): string | null {
  const raw = String(hash || '').trim();
  if (!raw) return null;
  const h = raw.startsWith('#') ? raw.slice(1) : raw;
  if (!h) return null;
  let join = '';
  try {
    const params = new URLSearchParams(h.startsWith('?') ? h.slice(1) : h);
    join = String(params.get('join') ?? '');
  } catch {
    join = '';
  }
  if (!join && h.startsWith('join=')) join = h.slice('join='.length).split('&')[0] ?? '';
  const clean = join.replace(/[^a-zA-Z0-9]/g, '');
  return /^[a-zA-Z0-9]{8}$/.test(clean) ? clean : null;
}

export function setJoinReplayIdHash(replayId: string) {
  const clean = String(replayId || '').replace(/[^a-zA-Z0-9]/g, '');
  if (!/^[a-zA-Z0-9]{8}$/.test(clean)) return;
  const desired = `#join=${clean}`;
  if (window.location.hash === desired) return;
  // Keep the URL shareable without cluttering history.
  try {
    history.replaceState(null, '', desired);
  } catch {
    window.location.hash = desired;
  }
}

export function extractReplayId(replay: ReplayJson): string {
  const raw = String(replay?.info?.gameID ?? replay?.gameID ?? '').trim();
  const clean = raw.replace(/[^a-zA-Z0-9]/g, '');
  if (!/^[a-zA-Z0-9]{8}$/.test(clean)) {
    throw new Error('Invalid replay: missing replay ID (expected replay.info.gameID or replay.gameID, 8 alnum chars)');
  }
  return clean;
}

export function replayKeyForId(replayId: string) {
  return `id:${replayId}`;
}

